import { Link } from "@tanstack/react-router";
import { CircleAlert, Compass } from "lucide-react";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { AppConfig } from "@/common/appConfig";
import { Button } from "@/components/ui/button";
import { V3Button } from "@/components/ui/v3/button";
import { StandaloneFrame } from "@/components/ui/v3/standalone-frame";

export const NotFoundPage: FunctionComponent = () => {
  const { t } = useTranslation();

  if (AppConfig.enableAppRedesign)
    return (
      <StandaloneFrame>
        <span
          aria-hidden
          className="mx-auto flex size-12 items-center justify-center rounded-[14px] bg-v3-surface-2 text-v3-text shadow-v3-hairline"
        >
          <Compass className="size-6" />
        </span>
        <h1
          className="mt-4 text-[20px] font-semibold leading-7 tracking-tight text-v3-text"
          data-testid="not-found-title"
        >
          {t("notFound.v3.title")}
        </h1>
        <p className="mt-1.5 text-[14px] leading-relaxed text-v3-text-2">
          {t("notFound.v3.description")}
        </p>
        <V3Button asChild className="mt-6 w-full sm:w-auto" variant="primary">
          <Link data-testid="not-found-home" to="/visits">
            {t("notFound.v3.btnTitle")}
          </Link>
        </V3Button>
      </StandaloneFrame>
    );

  return (
    <StandaloneFrame>
      <div className="flex justify-center mb-4">
        <CircleAlert />
      </div>

      <h6 className="font-bold">{t("notFound.title")}</h6>

      <p className="mt-2">{t("notFound.description")}</p>

      <Link to={"/"}>
        <Button
          className="mt-6"
          data-testid="signUp-submit-button"
          size="lg"
          type="submit"
        >
          {t("notFound.btnTitle")}
        </Button>
      </Link>
    </StandaloneFrame>
  );
};
